export default __webpack_public_path__ + "static/media/2.1994b151.png";